import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Login from '~/pages/Login';
import RequireAuth from '~/components/RequireAuth';

// Login is statically imported, so it lives in the "login-*" chunk (served to
// anyone). Everything under pages/app/* + components/app/* is lazy-loaded so it
// ends up in the protected "comedy-*" chunk, which the edge gate refuses to
// serve to an unauthenticated browser. See netlify/edge-functions/auth-gate.ts
// and scripts/verify-chunk-split.sh.
const AppLayout = lazy(() => import('~/components/app/AppLayout'));
const Directory = lazy(() => import('~/pages/app/Directory'));
const EntityDetailPage = lazy(() => import('~/pages/app/EntityDetailPage'));
const PersonalBits = lazy(() => import('~/pages/app/PersonalBits'));
const ComedyGuide = lazy(() => import('~/pages/app/ComedyGuide'));

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="p-6 text-neutral-400">Loading…</div>}>{children}</Suspense>
);

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: (
          <Lazy>
            <AppLayout />
          </Lazy>
        ),
        children: [
          { path: '/', element: <Lazy><Directory /></Lazy> },
          { path: '/e/:nodeId', element: <Lazy><EntityDetailPage /></Lazy> },
          { path: '/personal', element: <Lazy><PersonalBits /></Lazy> },
          { path: '/guide', element: <Lazy><ComedyGuide /></Lazy> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
